exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".automation-wrapper[data-v-e7bab182] {\n  max-width: 100%;\n  height: 300px;\n  overflow-x: clip;\n  position: relative;\n}\n.content[data-v-e7bab182] {\n  background-color: white;\n  padding: 22px;\n  border-radius: 8px;\n}\n.content p[data-v-e7bab182] {\n  margin: 0 !important;\n  font-size: 14px !important;\n}", ""]);

// exports
